import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'rl-search',
  templateUrl : './search.component.html',
  styleUrls: ['./search.component.scss', './search.component-rtl.css']
})
export class SearchComponent{

  @Input() showSearch? : boolean = false;
  @Input() options? : string[] = [];
  @Output() onSearch = new EventEmitter<string>();
  @Output() showSearchChange? = new EventEmitter<boolean>();
  @Output() getNextResult? = new EventEmitter<void>();
  @Output() getPrevResult? = new EventEmitter<void>();

  searchTerm : string;
  resultsNum : number = 0;
  _totalResults : number;
  showResults : boolean = false;
  nextEnabled : boolean;
  prevEnabled : boolean;
  
  constructor() { }

  ngOnInit(): void {
      this.nextEnabled = this.getNextResult.observers.length > 0;
      this.prevEnabled = this.getPrevResult.observers.length > 0;
  }
  
  set totalResults(totalResults : number){
    this.showResults = this.showSearch;
    if (!totalResults) {
      this._totalResults = 0;
      this.resultsNum = 0;
    }else{
      this._totalResults = totalResults;
      this.resultsNum = 1;
    }
  };

  search(str = ""): void {
    this.onSearch.emit(str);
  }

  toggleShowSearch(){
    this.showSearch = !this.showSearch;
    if(!this.showSearch){
      this.search(this.searchTerm = '');
      this.totalResults = 0;
    }
    
    this.showSearchChange.emit(this.showSearch);
  }

  nextResult(){
    if(++this.resultsNum > this._totalResults){
      this.resultsNum = 1;
    }
    this.getNextResult.emit();
  }

  
  prevResult(){
    if(--this.resultsNum < 1){
      this.resultsNum = this._totalResults;
    }
    this.getPrevResult.emit();
  }


}